import { FOOD_SUBCATEGORY_SVG_BY_KEY } from './categoryFoodSubmenuSvg';

const PC = '/icons/personal-care';
const HC = '/icons/household-cleaning';
const CT = '/icons/construction';

/**
 * Alt kategori küçük görselleri — Food için SVG; diğerleri public/categories/{region}/…
 * Eksik anahtarlar için güvenli varsayılan.
 */
export const SUBCATEGORY_THUMB_SRC = {
  Pasta: '/categories/middle-east/pasta.png',
  'Wheat Flour': '/categories/asia/wheat-flour.png',
  Bulgur: '/categories/middle-east/bulgur.png',
  Semolina: '/categories/middle-east/semolina.png',
  'Tomato Paste': '/categories/asia/tomato-paste.png',
  '100% Juice': '/categories/asia/juice.png',
  'Organic Juice': '/categories/usa/organic-juice.png',
  'Fruit Drink': '/categories/africa/fruit-drink.png',
  'Energy Drink': '/categories/africa/energy-drink.png',
  'Edible Oils': '/categories/middle-east/sunflower-oil.png',
  'Sunflower Oil': '/categories/middle-east/sunflower-oil.png',
  'Olive Oil': '/categories/middle-east/sunflower-oil.png',
  Pickles: '/categories/usa/pickle.png',
  'Grape Leaves': '/categories/middle-east/grape-leaves.png',
  'Stuffed Grape Leaves': '/categories/usa/grape-leaves.png',
  'Dried Fruits': '/categories/asia/dried-fruit.png',
  Salt: '/categories/middle-east/pasta.png',
  Noodle: '/categories/middle-east/pasta.png',
  'Roasted Red Pepper': '/categories/asia/tomato-paste.png',
  'Roasted Eggplant': '/categories/asia/tomato-paste.png',
  Jams: '/categories/middle-east/pasta.png',
  Chocolate: '/categories/middle-east/pasta.png',
  Candy: '/categories/middle-east/pasta.png',
  'Biscuit & Cookies': '/categories/middle-east/pasta.png',
  'Chips & Corn Flakes': '/categories/middle-east/pasta.png',
  'Iced Coffee': '/categories/asia/juice.png',
  'Ice Coffee': '/categories/asia/juice.png',
  'Mineral Water': '/categories/asia/juice.png',
  Nectar: '/categories/asia/juice.png',
  'Fruit Juices': '/categories/asia/juice.png',
  Confectionery: '/categories/middle-east/pasta.png',
  'Fresh Vegetables & Fruits': '/categories/usa/pickle.png',
  Marble: `${CT}/marble.svg`,
  'Ceramic Tile': `${CT}/tiles.svg`,
  'Ceramic & Porcelain Tile': `${CT}/tiles.svg`,
  Cement: `${CT}/cement.svg`,
  Paint: `${CT}/paint.svg`,
  'Paint & Coating': `${CT}/paint.svg`,
  'Laundry Detergent': `${HC}/laundry-detergent.svg`,
  'Dishwashing Detergent': `${HC}/dishwashing-detergent.svg`,
  'Dishwashing Tablet': `${HC}/dishwasher-tablet.svg`,
  'Liquid Soap': `${HC}/liquid-soap.svg`,
  'Fabric Softener': `${HC}/fabric-softener.svg`,
  'Surface Cleaner': `${HC}/surface-cleaner.svg`,
  'Glass Cleaner': `${HC}/glass-cleaner.svg`,
  'Dishwasher Rinse Aid': `${HC}/dish-brightener.svg`,
  'Dish Brightener': `${HC}/dish-brightener.svg`,
  'Drain Opener': `${HC}/drain-opener.svg`,
  'Rust & Lime Remover': `${HC}/rust-lime-remover.svg`,
  'Baby Diaper': `${PC}/baby-diaper.svg`,
  'Toilet Paper': `${PC}/toilet-paper.svg`,
  'Paper Towel': `${PC}/paper-towel.svg`,
  'Wet Wipes': `${PC}/wet-wipes.svg`,
  'Baby Wet Wipes': `${PC}/baby-wet-towel.svg`,
  'Wet Baby Towel': `${PC}/baby-wet-towel.svg`,
  'Sanitary Napkin': `${PC}/sanitary-napkin.svg`,
  'Sanitery Napkin': `${PC}/sanitary-napkin.svg`,
  'Napkins & Facial Tissues': `${PC}/napkin-facial-tissue.svg`,
  'Napkin - Facial Tissue': `${PC}/napkin-facial-tissue.svg`,
  'Handkerchief - Pocket Tissue': `${PC}/handkerchief-pocket-tissue.svg`,
};

const ICON_CACHE_VER = '2';

export function getSubcategoryThumbSrc(subKey) {
  const k = (subKey || '').trim();
  if (FOOD_SUBCATEGORY_SVG_BY_KEY[k]) return null;
  const src = SUBCATEGORY_THUMB_SRC[k] || '/categories/middle-east/pasta.png';
  return `${src}?v=${ICON_CACHE_VER}`;
}
